import React, { createContext, useContext } from 'react';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import {
  AdvancedFilterConfig,
  Paths,
  QuestionFilterConfig,
  RankingDisabledReason,
  EducationFilterConfig,
} from 'talent_matching/types';

export interface TalentMatchingTabContextValue {
  paths: Paths;
  canAdvance: boolean;
  canReject: boolean;
  canEmail: boolean;
  canBulkEdit: boolean;
  canCreateCalibrationSetting: boolean;
  canEditAndDeleteTalentMatchingCalibration: boolean;
  canViewTalentMatchingAiMatchScore: boolean;
  locationFilterReadOnly: boolean;
  canParseResumes: boolean;
  canUseFraudFilter: boolean;
  rankingDisabledReason: RankingDisabledReason | null;
  canDownloadCandidateData: boolean;
  advancedFilterConfig: AdvancedFilterConfig;
  questionFilterConfig: QuestionFilterConfig;
  educationFilterConfig: EducationFilterConfig;
  activeSidePanelTab: string | null;
  setActiveSidePanelTab: (tab: string) => void;
  feedbackOnly: boolean;
  jobTitle: string;
  appReviewSessionId: number;
  savedSearchOptions: Item[];
  setSavedSearchOptions: (options: Item[]) => void;
  canViewFraudReports: boolean;
  canRunFraudReports: boolean;
}

const TalentMatchingTabContext = createContext<
  TalentMatchingTabContextValue | undefined
>(undefined);

export const useTalentMatchingTabContext = () => {
  const context = useContext(TalentMatchingTabContext);
  if (!context) {
    throw new Error(
      'useTalentMatchingTabContext must be used within a TalentMatchingTabContextProvider'
    );
  }
  return context;
};

export const TalentMatchingTabContextProvider = ({
  value,
  children,
}: {
  value: TalentMatchingTabContextValue;
  children: React.ReactNode;
}) => {
  return (
    <TalentMatchingTabContext.Provider value={value}>
      {children}
    </TalentMatchingTabContext.Provider>
  );
};
